const isUUIDValid = (uuid) => {
  if (!uuid) return false;

  return uuid.length === 36;
};

export const getUUID = () => {
  const parts = window.location.href.split("/");

  if (!parts || !parts.length) return "";

  for (let i = parts.length - 1; i > 0; i--) {
    if (!parts[i]) continue;

    const paramsStarts = parts[i].lastIndexOf("?");
    if (paramsStarts !== -1) {
      const part = parts[i].substring(0, paramsStarts);

      if (isUUIDValid(part)) return part;
    }

    if (isUUIDValid(parts[i])) return parts[i];
  }

  return "";
};
